<div class="container">
    @for (check of checksBySeverity(); track check) {
        @let severity = check[0];
        <h4><i class="far {{CheckUtils.asFontAwesomeIconClass(severity)}}"></i> {{checkHeader(severity)}}</h4>
        <ul>
            @for (item of check[1]; track item) {
                <li>{{item.name}}</li>
            }
        </ul>
    }
</div>
